import { USER_GROUP } from './user';

export const WITHDRAWAL_MODAL_AB_TEST = 'withdrawal_modal_for_not_verified';

export enum NotVerifiedWithdrawalABTestVersion {
  A_DEFAULT = 'a_default_withdrawal_page',
  B_WITH_MESSAGE = 'b_withdrawal_page_verification_request',
}

export const WITHDRAWAL_MODAL_AB_TEST_CONFIG = {
  defaultVersion: NotVerifiedWithdrawalABTestVersion.A_DEFAULT,
  userGroup: USER_GROUP.FIAT_PLAYERS,
  versions: [
    {
      name: NotVerifiedWithdrawalABTestVersion.A_DEFAULT,
      probability: 50,
    },
    {
      name: NotVerifiedWithdrawalABTestVersion.B_WITH_MESSAGE,
      probability: 50,
    },
  ],
};
